import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function LateIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#FEE4E2"
      />
      <path
        d="M10.8288 5.27273L10.6882 11.4347H9.31605L9.17969 5.27273H10.8288ZM10.0021 14.0938C9.74361 14.0938 9.52202 14.0028 9.33736 13.821C9.15554 13.6392 9.06463 13.4176 9.06463 13.1562C9.06463 12.9006 9.15554 12.6818 9.33736 12.5C9.52202 12.3182 9.74361 12.2273 10.0021 12.2273C10.255 12.2273 10.4737 12.3182 10.6584 12.5C10.8459 12.6818 10.9396 12.9006 10.9396 13.1562C10.9396 13.3295 10.8956 13.4872 10.8075 13.6293C10.7223 13.7713 10.6087 13.8849 10.4666 13.9702C10.3274 14.0526 10.1726 14.0938 10.0021 14.0938Z"
        fill="#D92C20"
      />
    </svg>
  );
};
